module.exports = __webpack_public_path__ + "img/GOTA_ADV.05c9b2ed.png";